import '../../styles/textStyle.css';
import '../hooks/useAutofillEvent.css';
import './BaseInput.css';
export var container = '_183n8r66-2-0-1';
export var disabled = '_183n8r62-2-0-1';
export var hasError = '_183n8r61-2-0-1';
export var input = '_183n8r67-2-0-1 _ttpug73-2-0-1 _3xlztp0-2-0-1 _3xlztp2-2-0-1 _3xlztp3-2-0-1 _3xlztpb-2-0-1';
export var isAutoFilled = '_183n8r68-2-0-1';
export var variant = {'default':'_183n8r63-2-0-1',minimal:'_183n8r64-2-0-1'};
export var wrapper = '_183n8r60-2-0-1';